import { render } from "./RubleIcon.vue?vue&type=template&id=ce6b2f02&scoped=true"
import script from "./RubleIcon.vue?vue&type=script&lang=js"
export * from "./RubleIcon.vue?vue&type=script&lang=js"

import "./RubleIcon.vue?vue&type=style&index=0&id=ce6b2f02&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6b2f02"]])

export default __exports__